import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';
import type { IssueFormSummary } from '../../../api/issueDetailApi';

interface InterventionsListProps {
  forms: IssueFormSummary[];
  isLoading: boolean;
  onOpen: (form: IssueFormSummary) => void;
}

export const InterventionsList = ({ forms, isLoading, onOpen }: InterventionsListProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex justify-center py-6" role="status">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary"></div>
        <span className="sr-only">{t('Loading…')}</span>
      </div>
    );
  }

  if (!forms.length) {
    return <p className="text-sm text-gray-500">{t('No intervention')}</p>;
  }

  return (
    <ul className="divide-y divide-gray-200">
      {forms.map((form) => (
        <li key={form.id} className="flex items-center justify-between gap-3 py-3">
          <div className="flex items-center gap-3 min-w-0">
            <span className="truncate text-sm font-medium text-gray-900" title={form.name}>
              {form.name}
            </span>
            <span
              className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${
                form.submitted ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
              }`}
            >
              {form.submitted ? t('Submitted') : t('Not submitted')}
            </span>
          </div>
          <button
            type="button"
            onClick={() => onOpen(form)}
            className="inline-flex shrink-0 items-center gap-1 rounded px-2 py-1 text-sm text-primary hover:bg-primary/10"
          >
            <Eye className="w-4 h-4" />
            {t('View')}
          </button>
        </li>
      ))}
    </ul>
  );
};
